'use strict'

import http from "@helpers/http";

export default {
    install(app) {
        app.config.globalProperties.$http = http;
    }
};
